import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import React, { useMemo } from 'react'

import { quartersIsInconsistency } from '../../helpers/financialInconsistencies/quartersIsInconsistency'
import { IWarningMessage } from '../../inconcistencyWrapper/models'
import { IIsInconsistencyPayload } from '../../models'
import { warningQuartersInconsistencyMsg } from '../config'

interface IProps {
  keyValue: TRevenueSnapshotKeys
  isInconsistency: (args: IIsInconsistencyPayload) => boolean
  yearField: keyof IRevenue
  quarterFields: (keyof IRevenue)[]
}

export const useYearResultColumn = ({
  keyValue,
  yearField,
  quarterFields,
  isInconsistency,
}: IProps) => {
  const checkQuartersInconsistencyFn = useMemo(
    () => quartersIsInconsistency({ keyValue, yearField, quarterFields }),
    [keyValue, yearField]
  )

  const isInconsistencyQuartersResult = isInconsistency({
    fn: checkQuartersInconsistencyFn,
  })

  const warningMessages: IWarningMessage[] = useMemo(() => {
    const warningMsgs: IWarningMessage[] = []

    if (isInconsistencyQuartersResult) {
      warningMsgs.push({ text: warningQuartersInconsistencyMsg })
    }

    return warningMsgs
  }, [keyValue, isInconsistencyQuartersResult])

  const showWarningWrapper = isInconsistencyQuartersResult

  return { showWarningWrapper, warningMessages }
}
